import type { FC, ReactNode } from 'react'

import Reveal from '@/components/landing/reveal'
import PhotoFilm from '@/components/landing/photo-film'
import ClipsPlayer from '@/components/landing/clips-player'
import SectionHeading from '@/components/landing/section-heading'
import { VIDEOS } from '@/constants/birthday'

const VideoMemoriesSection: FC = (): ReactNode => {
    return (
        <section id='videos' aria-labelledby='videos-title' className='relative isolate overflow-hidden bg-wine py-24 text-white sm:py-32'>
            <div aria-hidden className='pointer-events-none absolute inset-0 -z-10 overflow-hidden'>
                <div className='absolute -left-40 top-10 size-[28rem] rounded-full bg-primary/25 blur-3xl' />
                <div className='absolute -right-32 bottom-0 size-[26rem] rounded-full bg-gold/10 blur-3xl' />
            </div>

            <div className='mx-auto max-w-6xl px-5 sm:px-8'>
                <Reveal>
                    <SectionHeading
                        id='videos-title'
                        tone='dark'
                        title={VIDEOS.title}
                        subtitle={VIDEOS.subtitle}
                    />
                </Reveal>

                <Reveal className='mt-14'>
                    <PhotoFilm />
                </Reveal>

                <Reveal className='mt-24 sm:mt-28'>
                    <ClipsPlayer />
                </Reveal>
            </div>
        </section>
    )
}

export default VideoMemoriesSection
